import { faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { faSwimmer } from "@fortawesome/free-solid-svg-icons";
import { faClock } from "@fortawesome/free-solid-svg-icons";

const aboutUs = [
    {
        icon: faBriefcase,
        title: "Efficient",
        text: "Crystal Clear Pool & Spa Service is the company of choice for pool owners in the greater Napa area who are looking for a professional, qualified and affordable pool maintenance team. Our years of training and experience not only make us knowledgeable, they also make us the very best company in Napa to handle most any pool maintenance and repair service quickly and efficiently."
    },
    {
        icon: faSwimmer,
        title: "Dedicated",
        text: "We have been proudly offering pool maintenance and repair services to Napa residents for many years. Being pool enthusiasts ourselves, we understand the commitment as well as the investment you have made when you became a Napa pool owner. We know how much work needs to be put in and around your pool to keep it clean, safe and enjoyable, and we also understand that, unlike us, caring for your Napa pool shouldn't be your primary occupation. Why spend more time on pool maintenance than on actually enjoying your pool?"
    },
    {
        icon: faClock,
        title: "Experienced",
        text: "Crystal Clear Pool & Spa Service will be happy to take on part or all of your Napa pool maintenance, repair and renovation duties, allowing you more time to make the most of your investment in your free time. Crystal Clear Pool & Spa Service offers regular maintenance services, such as weekly Napa pool cleaning and chlorine monitoring as well as seasonal and unscheduled maintenance and repair services, such as pool painting and tile repair. Whatever your needs or your budget, we can help."
    }
];

export default aboutUs;